import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AppConfigService } from '../../configs/app-config.service';


@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  configs = new AppConfigService();

  constructor(public router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (sessionStorage.getItem('isLoggedIn')) {
      if (state.url === '/login') { this.router.navigate(['/']); };
      // logged in so return true
      return true;
    }


    if(this.configs.authenticationConfigurationType=='local'){
      this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
    }else{
      window.open(this.configs.identityServerUrl,'_self');
    }
    // not logged in so redirect to login page with the return url

   //  window.open(this.configs.identityServerUrl,'_self');
    
    return false;
  }
  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.canActivate(route, state);
  }
  canActivateMain(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return true;
  }

}
